import { TimeTargetingHoursSelectType } from '../service/TimeTargetingEditorHelper/TimeTargetingEditorHelper';
import {
    TimeTargetingEditorState,
    TimeTargetingSelectedItem,
    TimeTargetingValue
} from '../typings/timeTargetingEditor';

export const OPEN_TIME_TARGETING_EDITOR = 'OPEN_TIME_TARGETING_EDITOR';
export type OPEN_TIME_TARGETING_EDITOR = typeof OPEN_TIME_TARGETING_EDITOR;

export interface OpenTimeTargetingEditor {
    type: OPEN_TIME_TARGETING_EDITOR;
    editorId: string;
    savedValue: TimeTargetingValue;
}

export function openTimeTargetingEditor(
    editorId: string,
    savedValue: TimeTargetingValue
): OpenTimeTargetingEditor {
    return {
        type: OPEN_TIME_TARGETING_EDITOR,
        editorId,
        savedValue
    };
}

export const CLOSE_TIME_TARGETING_EDITOR = 'CLOSE_TIME_TARGETING_EDITOR';
export type CLOSE_TIME_TARGETING_EDITOR = typeof CLOSE_TIME_TARGETING_EDITOR;

export interface CloseTimeTargetingEditor {
    type: CLOSE_TIME_TARGETING_EDITOR;
    editorId: string;
}

export function closeTimeTargetingEditor(
    editorId: string
): CloseTimeTargetingEditor {
    return {
        type: CLOSE_TIME_TARGETING_EDITOR,
        editorId
    };
}

export const UPDATE_TIME_TARGETING_EDITOR = 'UPDATE_TIME_TARGETING_EDITOR';
export type UPDATE_TIME_TARGETING_EDITOR = typeof UPDATE_TIME_TARGETING_EDITOR;

export interface UpdateTimeTargetingEditor {
    type: UPDATE_TIME_TARGETING_EDITOR;
    editorId: string;
    value: TimeTargetingEditorState;
}

export function updateTimeTargetingEditor(
    editorId: string,
    value: TimeTargetingEditorState
): UpdateTimeTargetingEditor {
    return {
        type: UPDATE_TIME_TARGETING_EDITOR,
        editorId,
        value
    };
}

export const QUICK_SELECT_DAYS_FOR_TIME_TARGETING_EDITOR =
    'QUICK_SELECT_DAYS_FOR_TIME_TARGETING_EDITOR';
export type QUICK_SELECT_DAYS_FOR_TIME_TARGETING_EDITOR = typeof QUICK_SELECT_DAYS_FOR_TIME_TARGETING_EDITOR;

export interface QuickSelectDaysForTimeTargetingEditor {
    type: QUICK_SELECT_DAYS_FOR_TIME_TARGETING_EDITOR;
    editorId: string;
    selectedDays: number[];
}

export function quickSelectDaysForTimeTargetingEditor(
    editorId: string,
    selectedDays: number[]
): QuickSelectDaysForTimeTargetingEditor {
    return {
        type: QUICK_SELECT_DAYS_FOR_TIME_TARGETING_EDITOR,
        editorId,
        selectedDays
    };
}

export const QUICK_SELECT_HOURS_FOR_TIME_TARGETING_EDITOR =
    'QUICK_SELECT_HOURS_FOR_TIME_TARGETING_EDITOR';
export type QUICK_SELECT_HOURS_FOR_TIME_TARGETING_EDITOR = typeof QUICK_SELECT_HOURS_FOR_TIME_TARGETING_EDITOR;

export interface QuickSelectHoursForTimeTargetingEditor {
    type: QUICK_SELECT_HOURS_FOR_TIME_TARGETING_EDITOR;
    editorId: string;
    selectedType: TimeTargetingHoursSelectType;
}

export function quickSelectHoursForTimeTargetingEditor(
    editorId: string,
    selectedType: TimeTargetingHoursSelectType
): QuickSelectHoursForTimeTargetingEditor {
    return {
        type: QUICK_SELECT_HOURS_FOR_TIME_TARGETING_EDITOR,
        editorId,
        selectedType
    };
}

export const QUICK_CHECK_DAY_FOR_TIME_TARGETING_EDITOR =
    'QUICK_CHECK_DAY_FOR_TIME_TARGETING_EDITOR';
export type QUICK_CHECK_DAY_FOR_TIME_TARGETING_EDITOR = 'QUICK_CHECK_DAY_FOR_TIME_TARGETING_EDITOR';

export interface QuickCheckDayForTimeTargetingEditor {
    type: QUICK_CHECK_DAY_FOR_TIME_TARGETING_EDITOR;
    editorId: string;
    indexDay: number;
}

export function quickCheckDayForTimeTargetingEditor(
    editorId: string,
    indexDay: number
): QuickCheckDayForTimeTargetingEditor {
    return {
        type: QUICK_CHECK_DAY_FOR_TIME_TARGETING_EDITOR,
        editorId,
        indexDay
    };
}

export const CHANGE_START_TIME_FOR_TIME_TARGETING_EDITOR =
    'CHANGE_START_TIME_FOR_TIME_TARGETING_EDITOR';
export type CHANGE_START_TIME_FOR_TIME_TARGETING_EDITOR = typeof CHANGE_START_TIME_FOR_TIME_TARGETING_EDITOR;

export interface ChangeStartTimeForTimeTargetingEditor {
    type: CHANGE_START_TIME_FOR_TIME_TARGETING_EDITOR;
    editorId: string;
    value: string;
}

export function changeStartTimeForTimeTargetingEditor(
    editorId: string,
    value: string
): ChangeStartTimeForTimeTargetingEditor {
    return {
        type: CHANGE_START_TIME_FOR_TIME_TARGETING_EDITOR,
        editorId,
        value
    };
}

export const CHANGE_END_TIME_FOR_TIME_TARGETING_EDITOR =
    'CHANGE_END_TIME_FOR_TIME_TARGETING_EDITOR';
export type CHANGE_END_TIME_FOR_TIME_TARGETING_EDITOR = typeof CHANGE_END_TIME_FOR_TIME_TARGETING_EDITOR;

export interface ChangeEndTimeForTimeTargetingEditor {
    type: CHANGE_END_TIME_FOR_TIME_TARGETING_EDITOR;
    editorId: string;
    value: string;
}

export function changeEndTimeForTimeTargetingEditor(
    editorId: string,
    value: string
): ChangeEndTimeForTimeTargetingEditor {
    return {
        type: CHANGE_END_TIME_FOR_TIME_TARGETING_EDITOR,
        editorId,
        value
    };
}

export const APPLY_START_TIME_FOR_TIME_TARGETING_EDITOR =
    'APPLY_START_TIME_FOR_TIME_TARGETING_EDITOR';
export type APPLY_START_TIME_FOR_TIME_TARGETING_EDITOR = typeof APPLY_START_TIME_FOR_TIME_TARGETING_EDITOR;

export interface ApplyStartTimeForTimeTargetingEditor {
    type: APPLY_START_TIME_FOR_TIME_TARGETING_EDITOR;
    editorId: string;
}

export function applyStartTimeForTimeTargetingEditor(
    editorId: string
): ApplyStartTimeForTimeTargetingEditor {
    return {
        type: APPLY_START_TIME_FOR_TIME_TARGETING_EDITOR,
        editorId
    };
}

export const APPLY_END_TIME_FOR_TIME_TARGETING_EDITOR =
    'APPLY_END_TIME_FOR_TIME_TARGETING_EDITOR';
export type APPLY_END_TIME_FOR_TIME_TARGETING_EDITOR = typeof APPLY_END_TIME_FOR_TIME_TARGETING_EDITOR;

export interface ApplyEndTimeForTimeTargetingEditor {
    type: APPLY_END_TIME_FOR_TIME_TARGETING_EDITOR;
    editorId: string;
}

export function applyEndTimeForTimeTargetingEditor(
    editorId: string
): ApplyEndTimeForTimeTargetingEditor {
    return {
        type: APPLY_END_TIME_FOR_TIME_TARGETING_EDITOR,
        editorId
    };
}

export const CHANGE_START_TIME_HOLIDAYS_FOR_TIME_TARGETING_EDITOR =
    'CHANGE_START_TIME_HOLIDAYS_FOR_TIME_TARGETING_EDITOR';
export type CHANGE_START_TIME_HOLIDAYS_FOR_TIME_TARGETING_EDITOR = typeof CHANGE_START_TIME_HOLIDAYS_FOR_TIME_TARGETING_EDITOR;

export interface ChangeStartTimeHolidaysForTimeTargetingEditor {
    type: CHANGE_START_TIME_HOLIDAYS_FOR_TIME_TARGETING_EDITOR;
    editorId: string;
    value: string;
}

export function changeStartTimeHolidaysForTimeTargetingEditor(
    editorId: string,
    value: string
): ChangeStartTimeHolidaysForTimeTargetingEditor {
    return {
        type: CHANGE_START_TIME_HOLIDAYS_FOR_TIME_TARGETING_EDITOR,
        editorId,
        value
    };
}

export const CHANGE_END_TIME_HOLIDAYS_FOR_TIME_TARGETING_EDITOR =
    'CHANGE_END_TIME_HOLIDAYS_FOR_TIME_TARGETING_EDITOR';
export type CHANGE_END_TIME_HOLIDAYS_FOR_TIME_TARGETING_EDITOR = typeof CHANGE_END_TIME_HOLIDAYS_FOR_TIME_TARGETING_EDITOR;

export interface ChangeEndTimeHolidaysForTimeTargetingEditor {
    type: CHANGE_END_TIME_HOLIDAYS_FOR_TIME_TARGETING_EDITOR;
    editorId: string;
    value: string;
}

export function changeEndTimeHolidaysForTimeTargetingEditor(
    editorId: string,
    value: string
): ChangeEndTimeHolidaysForTimeTargetingEditor {
    return {
        type: CHANGE_END_TIME_HOLIDAYS_FOR_TIME_TARGETING_EDITOR,
        editorId,
        value
    };
}

export const APPLY_START_TIME_HOLIDAYS_FOR_TIME_TARGETING_EDITOR =
    'APPLY_START_TIME_HOLIDAYS_FOR_TIME_TARGETING_EDITOR';
export type APPLY_START_TIME_HOLIDAYS_FOR_TIME_TARGETING_EDITOR = typeof APPLY_START_TIME_HOLIDAYS_FOR_TIME_TARGETING_EDITOR;

export interface ApplyStartTimeHolidaysForTimeTargetingEditor {
    type: APPLY_START_TIME_HOLIDAYS_FOR_TIME_TARGETING_EDITOR;
    editorId: string;
}

export function applyStartTimeHolidaysForTimeTargetingEditor(
    editorId: string
): ApplyStartTimeHolidaysForTimeTargetingEditor {
    return {
        type: APPLY_START_TIME_HOLIDAYS_FOR_TIME_TARGETING_EDITOR,
        editorId
    };
}

export const APPLY_END_TIME_HOLIDAYS_FOR_TIME_TARGETING_EDITOR =
    'APPLY_END_TIME_HOLIDAYS_FOR_TIME_TARGETING_EDITOR';
export type APPLY_END_TIME_HOLIDAYS_FOR_TIME_TARGETING_EDITOR = typeof APPLY_END_TIME_HOLIDAYS_FOR_TIME_TARGETING_EDITOR;

export interface ApplyEndTimeHolidaysForTimeTargetingEditor {
    type: APPLY_END_TIME_HOLIDAYS_FOR_TIME_TARGETING_EDITOR;
    editorId: string;
}

export function applyEndTimeHolidaysForTimeTargetingEditor(
    editorId: string
): ApplyEndTimeHolidaysForTimeTargetingEditor {
    return {
        type: APPLY_END_TIME_HOLIDAYS_FOR_TIME_TARGETING_EDITOR,
        editorId
    };
}

export const CHANGE_RATE_CORRECTIONS_FOR_TIME_TARGETING_EDITOR =
    'CHANGE_RATE_CORRECTIONS_FOR_TIME_TARGETING_EDITOR';
export type CHANGE_RATE_CORRECTIONS_FOR_TIME_TARGETING_EDITOR = typeof CHANGE_RATE_CORRECTIONS_FOR_TIME_TARGETING_EDITOR;

export interface ChangeRateCorrectionsForTimeTargetingEditor {
    type: CHANGE_RATE_CORRECTIONS_FOR_TIME_TARGETING_EDITOR;
    editorId: string;
    value: number;
}

export function changeRateCorrectionsForTimeTargetingEditor(
    editorId: string,
    value: number
): ChangeRateCorrectionsForTimeTargetingEditor {
    return {
        type: CHANGE_RATE_CORRECTIONS_FOR_TIME_TARGETING_EDITOR,
        editorId,
        value
    };
}

export const CHANGE_RATE_CORRECTIONS_HOLIDAYS_FOR_TIME_TARGETING_EDITOR =
    'CHANGE_RATE_CORRECTIONS_HOLIDAYS_FOR_TIME_TARGETING_EDITOR';
export type CHANGE_RATE_CORRECTIONS_HOLIDAYS_FOR_TIME_TARGETING_EDITOR = typeof CHANGE_RATE_CORRECTIONS_HOLIDAYS_FOR_TIME_TARGETING_EDITOR;

export interface ChangeRateCorrectionsHolidaysForTimeTargetingEditor {
    type: CHANGE_RATE_CORRECTIONS_HOLIDAYS_FOR_TIME_TARGETING_EDITOR;
    editorId: string;
    value: number;
}

export function changeRateCorrectionsHolidaysForTimeTargetingEditor(
    editorId: string,
    value: number
): ChangeRateCorrectionsHolidaysForTimeTargetingEditor {
    return {
        type: CHANGE_RATE_CORRECTIONS_HOLIDAYS_FOR_TIME_TARGETING_EDITOR,
        editorId,
        value
    };
}

export const SWITCH_ENABLED_RATE_CORRECTIONS_FOR_TIME_TARGETING_EDITOR =
    'SWITCH_ENABLED_RATE_CORRECTIONS_FOR_TIME_TARGETING_EDITOR';
export type SWITCH_ENABLED_RATE_CORRECTIONS_FOR_TIME_TARGETING_EDITOR = typeof SWITCH_ENABLED_RATE_CORRECTIONS_FOR_TIME_TARGETING_EDITOR;

export interface SwitchEnabledRateCorrectionsForTimeTargetingEditor {
    type: SWITCH_ENABLED_RATE_CORRECTIONS_FOR_TIME_TARGETING_EDITOR;
    editorId: string;
}

export function switchEnabledRateCorrectionsForTimeTargetingEditor(
    editorId: string
): SwitchEnabledRateCorrectionsForTimeTargetingEditor {
    return {
        type: SWITCH_ENABLED_RATE_CORRECTIONS_FOR_TIME_TARGETING_EDITOR,
        editorId
    };
}

export const CHANGE_BOARD_VALUES_FOR_TIME_TARGETING_EDITOR =
    'CHANGE_BOARD_VALUES_FOR_TIME_TARGETING_EDITOR';
export type CHANGE_BOARD_VALUES_FOR_TIME_TARGETING_EDITOR = typeof CHANGE_BOARD_VALUES_FOR_TIME_TARGETING_EDITOR;

export interface ChangeBoardValuesForTimeTargetingEditor {
    type: CHANGE_BOARD_VALUES_FOR_TIME_TARGETING_EDITOR;
    editorId: string;
    start: TimeTargetingSelectedItem;
    end: TimeTargetingSelectedItem;
    value: number;
}

export function changeBoardValuesForTimeTargetingEditor(
    editorId: string,
    start: TimeTargetingSelectedItem,
    end: TimeTargetingSelectedItem,
    value: number
): ChangeBoardValuesForTimeTargetingEditor {
    return {
        type: CHANGE_BOARD_VALUES_FOR_TIME_TARGETING_EDITOR,
        editorId,
        start,
        end,
        value
    };
}

export const SELECT_BOARD_COLUMN_FOR_TIME_TARGETING_EDITOR =
    'SELECT_BOARD_COLUMN_FOR_TIME_TARGETING_EDITOR';
export type SELECT_BOARD_COLUMN_FOR_TIME_TARGETING_EDITOR = typeof SELECT_BOARD_COLUMN_FOR_TIME_TARGETING_EDITOR;

export interface SelectBoardColumnForTimeTargetingEditor {
    type: SELECT_BOARD_COLUMN_FOR_TIME_TARGETING_EDITOR;
    editorId: string;
    index: number;
}

export function selectBoardColumnForTimeTargetingEditor(
    editorId: string,
    index: number
): SelectBoardColumnForTimeTargetingEditor {
    return {
        type: SELECT_BOARD_COLUMN_FOR_TIME_TARGETING_EDITOR,
        editorId,
        index
    };
}

export const SELECT_BOARD_ROW_FOR_TIME_TARGETING_EDITOR =
    'SELECT_BOARD_ROW_FOR_TIME_TARGETING_EDITOR';
export type SELECT_BOARD_ROW_FOR_TIME_TARGETING_EDITOR = typeof SELECT_BOARD_ROW_FOR_TIME_TARGETING_EDITOR;

export interface SelectBoardRowForTimeTargetingEditor {
    type: SELECT_BOARD_ROW_FOR_TIME_TARGETING_EDITOR;
    editorId: string;
    index: number;
}

export function selectBoardRowForTimeTargetingEditor(
    editorId: string,
    index: number
): SelectBoardRowForTimeTargetingEditor {
    return {
        type: SELECT_BOARD_ROW_FOR_TIME_TARGETING_EDITOR,
        editorId,
        index
    };
}

export const CANCEL_TIME_TARGETING_EDITOR = 'CANCEL_TIME_TARGETING_EDITOR';
export type CANCEL_TIME_TARGETING_EDITOR = typeof CANCEL_TIME_TARGETING_EDITOR;

export interface CancelTimeTargetingEditor {
    type: CANCEL_TIME_TARGETING_EDITOR;
    editorId: string;
    value: TimeTargetingValue;
}

export function cancelTimeTargetingEditor(
    editorId: string,
    value: TimeTargetingValue
): CancelTimeTargetingEditor {
    return {
        type: CANCEL_TIME_TARGETING_EDITOR,
        editorId,
        value
    };
}

export const UPDATE_VALIDATION_DATA_FOR_TIME_TARGETING_EDITOR =
    'UPDATE_VALIDATION_DATA_FOR_TIME_TARGETING_EDITOR';
export type UPDATE_VALIDATION_DATA_FOR_TIME_TARGETING_EDITOR = typeof UPDATE_VALIDATION_DATA_FOR_TIME_TARGETING_EDITOR;

export interface UpdateValidationDataForTimeTargetingEditor {
    type: UPDATE_VALIDATION_DATA_FOR_TIME_TARGETING_EDITOR;
    editorId: string;
}

export function updateValidationDataForTimeTargetingEditor(
    editorId: string
): UpdateValidationDataForTimeTargetingEditor {
    return {
        type: UPDATE_VALIDATION_DATA_FOR_TIME_TARGETING_EDITOR,
        editorId
    };
}

export const SWITCH_WORKING_WEEKENDS_FOR_TIME_TARGETING_EDITOR =
    'SWITCH_WORKING_WEEKENDS_FOR_TIME_TARGETING_EDITOR';
export type SWITCH_WORKING_WEEKENDS_FOR_TIME_TARGETING_EDITOR = typeof SWITCH_WORKING_WEEKENDS_FOR_TIME_TARGETING_EDITOR;

export interface SwitchWorkingWeekendsForTimeTargetingEditor {
    type: SWITCH_WORKING_WEEKENDS_FOR_TIME_TARGETING_EDITOR;
    editorId: string;
}

export function switchWorkingWeekendsForTimeTargetingEditor(
    editorId: string
): SwitchWorkingWeekendsForTimeTargetingEditor {
    return {
        type: SWITCH_WORKING_WEEKENDS_FOR_TIME_TARGETING_EDITOR,
        editorId
    };
}

export const SWITCH_HOLIDAYS_MODE_FOR_TIME_TARGETING_EDITOR =
    'SWITCH_HOLIDAYS_MODE_FOR_TIME_TARGETING_EDITOR';
export type SWITCH_HOLIDAYS_MODE_FOR_TIME_TARGETING_EDITOR = typeof SWITCH_HOLIDAYS_MODE_FOR_TIME_TARGETING_EDITOR;

export interface SwitchHolidaysModeForTimeTargetingEditor {
    type: SWITCH_HOLIDAYS_MODE_FOR_TIME_TARGETING_EDITOR;
    editorId: string;
}

export function switchHolidaysModeForTimeTargetingEditor(
    editorId: string
): SwitchHolidaysModeForTimeTargetingEditor {
    return {
        type: SWITCH_HOLIDAYS_MODE_FOR_TIME_TARGETING_EDITOR,
        editorId
    };
}

export const SWITCH_SHOW_MODE_HOLIDAYS_FOR_TIME_TARGETING_EDITOR =
    'SWITCH_SHOW_MODE_HOLIDAYS_FOR_TIME_TARGETING_EDITOR';
export type SWITCH_SHOW_MODE_HOLIDAYS_FOR_TIME_TARGETING_EDITOR = typeof SWITCH_SHOW_MODE_HOLIDAYS_FOR_TIME_TARGETING_EDITOR;

export interface SwitchShowModeHolidaysForTimeTargetingEditor {
    type: SWITCH_SHOW_MODE_HOLIDAYS_FOR_TIME_TARGETING_EDITOR;
    editorId: string;
    value: boolean;
}

export function switchShowModeHolidaysForTimeTargetingEditor(
    editorId: string,
    value: boolean
): SwitchShowModeHolidaysForTimeTargetingEditor {
    return {
        type: SWITCH_SHOW_MODE_HOLIDAYS_FOR_TIME_TARGETING_EDITOR,
        editorId,
        value
    };
}

export const SELECT_COUNTRY_TIME_ZONE_FOR_TIME_TARGETING_EDITOR =
    'SELECT_COUNTRY_TIME_ZONE_FOR_TIME_TARGETING_EDITOR';
export type SELECT_COUNTRY_TIME_ZONE_FOR_TIME_TARGETING_EDITOR = typeof SELECT_COUNTRY_TIME_ZONE_FOR_TIME_TARGETING_EDITOR;

export interface SelectCountryTimeZoneForTimeTargetingEditor {
    type: SELECT_COUNTRY_TIME_ZONE_FOR_TIME_TARGETING_EDITOR;
    editorId: string;
    id: string;
}

export function selectCountryTimeZoneForTimeTargetingEditor(
    editorId: string,
    id: string
): SelectCountryTimeZoneForTimeTargetingEditor {
    return {
        type: SELECT_COUNTRY_TIME_ZONE_FOR_TIME_TARGETING_EDITOR,
        editorId,
        id
    };
}

export const SELECT_TIME_ZONE_FOR_TIME_TARGETING_EDITOR =
    'SELECT_TIME_ZONE_FOR_TIME_TARGETING_EDITOR';
export type SELECT_TIME_ZONE_FOR_TIME_TARGETING_EDITOR = typeof SELECT_TIME_ZONE_FOR_TIME_TARGETING_EDITOR;

export interface SelectTimeZoneForTimeTargetingEditor {
    type: SELECT_TIME_ZONE_FOR_TIME_TARGETING_EDITOR;
    editorId: string;
    id: string;
}

export function selectTimeZoneForTimeTargetingEditor(
    editorId: string,
    id: string
): SelectTimeZoneForTimeTargetingEditor {
    return {
        type: SELECT_TIME_ZONE_FOR_TIME_TARGETING_EDITOR,
        editorId,
        id
    };
}

export type TimeTargetingEditorActions =
    | OpenTimeTargetingEditor
    | CloseTimeTargetingEditor
    | UpdateTimeTargetingEditor
    | QuickSelectDaysForTimeTargetingEditor
    | QuickSelectHoursForTimeTargetingEditor
    | ChangeStartTimeForTimeTargetingEditor
    | ChangeEndTimeForTimeTargetingEditor
    | ApplyStartTimeForTimeTargetingEditor
    | ApplyEndTimeForTimeTargetingEditor
    | ChangeRateCorrectionsForTimeTargetingEditor
    | SwitchEnabledRateCorrectionsForTimeTargetingEditor
    | ChangeBoardValuesForTimeTargetingEditor
    | SelectBoardColumnForTimeTargetingEditor
    | SelectBoardRowForTimeTargetingEditor
    | CancelTimeTargetingEditor
    | UpdateValidationDataForTimeTargetingEditor
    | QuickCheckDayForTimeTargetingEditor
    | SwitchWorkingWeekendsForTimeTargetingEditor
    | SwitchHolidaysModeForTimeTargetingEditor
    | SwitchShowModeHolidaysForTimeTargetingEditor
    | ChangeStartTimeHolidaysForTimeTargetingEditor
    | ChangeEndTimeHolidaysForTimeTargetingEditor
    | ApplyStartTimeHolidaysForTimeTargetingEditor
    | ApplyEndTimeHolidaysForTimeTargetingEditor
    | ChangeRateCorrectionsHolidaysForTimeTargetingEditor
    | SelectCountryTimeZoneForTimeTargetingEditor
    | SelectTimeZoneForTimeTargetingEditor;
